import { render } from "./App.vue?vue&type=template&id=47e5df02"
const script = {}

import "./App.vue?vue&type=style&index=0&id=47e5df02&lang=css"

import exportComponent from "D:\\curso VUE\\maps-app\\maps-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__